import { FC, useCallback } from "react";
import { Center } from "@chakra-ui/react";

import { useSbpTransferStore } from "../../../../store/sbpTransferStore.ts";
import { SbpTransferResultPageError } from "./SbpTransferResultPageError";
import { SbpTransferResultPageSuccess } from "./SbpTransferResultPageSuccess";
import { SbpTransferResultPageInProgress } from "./SbpTransferResultPageInProgress";

export const SbpTransferResultPageContent: FC = () => {
  const transferResult = useSbpTransferStore(state => state.transferResult);

  const renderContent = useCallback(() => {
    switch (transferResult?.status) {
      case "DONE":
        return <SbpTransferResultPageSuccess />;
      case "IN_PROGRESS":
        return <SbpTransferResultPageInProgress />;
      case "ERROR":
      default:
        return <SbpTransferResultPageError />;
    }
  }, [transferResult]);

  return (
    <Center flex="1" w="100%" maxW="300px" pb="100px">
      {renderContent()}
    </Center>
  );
};
